var map = {
	"./cg.svg": 30491,
	"./del.svg": 52056,
	"./del1.svg": 58057,
	"./hy.svg": 10620,
	"./inviteCode.svg": 56093,
	"./loading.svg": 36099,
	"./loading2.svg": 75067,
	"./lock.svg": 86592,
	"./msg.svg": 2784,
	"./pay.svg": 20125,
	"./save.svg": 77854,
	"./stop.svg": 26237,
	"./txt.svg": 63871,
	"./txt1.svg": 25020,
	"./updateFile.svg": 86848,
	"./updateFile1.svg": 74849,
	"./vip.svg": 38230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;